import { render } from "./ModalEmissorOrdem.vue?vue&type=template&id=2074f050&scoped=true"
import script from "./ModalEmissorOrdem.vue?vue&type=script&lang=js"
export * from "./ModalEmissorOrdem.vue?vue&type=script&lang=js"

import "./ModalEmissorOrdem.vue?vue&type=style&index=0&id=2074f050&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2074f050"]])

export default __exports__